import colors from '../../../assets/styles/variables/colors';

// Rapor renkleri tek kaynaktan (colors.report). styled-components içinde theme.colors.report kullanılır; bu modül
// tema bağlamı OLMAYAN yerler (hesaplanmış hücre rengi, react-pdf) içindir.
const palette = colors.report;

const BAND = {
  // Özet bantları (summaryBands): güçlü / izlenmeli / öncelikli.
  strong: { bg: palette.strongBg, fg: palette.blue },
  watch: { bg: palette.panel, fg: palette.text },
  priority: { bg: palette.priorityBg, fg: palette.orange },
  // Isı haritası bantları (heatmapBands 75/65/50): b1 en yüksek.
  // Spec 2026-10-16 U2: beyaz küçük rakam koyu mavi zeminde (brandDark); açık zeminde yazı koyu metin rengi.
  b1: { bg: palette.brandDark, fg: palette.paper },
  b2: { bg: palette.blueLight, fg: palette.text },
  b3: { bg: palette.grayLight, fg: palette.text },
  b4: { bg: palette.orangeLight, fg: palette.text },
};

export const bandColor = (band) => BAND[band] || { bg: palette.grayLight, fg: palette.muted };

export const DISTRIBUTION_COLORS = {
  unfavorable: palette.orange,
  neutral: palette.gray,
  favorable: palette.blue,
};

export default palette;
